import { Network, getNetworkEndpoints } from '@injectivelabs/networks'
import { ChainId, EthereumChainId } from '@injectivelabs/ts-types'
import { PublicKey } from '@ninjablaze/sdk-ts'

export enum Environmet {
  Testnet = 'testnet',
  Production = 'production',
}

const getNinjaBlazeEnv = (network: 'local' | 'testnet-dev' | 'mainnet') => {
  if (network == 'local') {
    return {
      ENVIRONMENT: Environmet.Production,
      CONTRACTS: {
        USER_PROFILE_ADDRESS: 'inj14hj2tavq8fpesdwxxcu44rty3hh90vhujaxlnz',
        JACKPOT_ADDRESS: 'inj1ghd753shjuwexxywmgs4xz7x2q732vcnxxynfn',
        FAUCET: 'inj1dxz43ljhsxztgatjduwtwtt943dz8fqvy4d8cs',
        ROULETTE_ADDRESS: 'inj1u4qunsax0s2au8ml8jfjee7hv6stw9htspgvhk',
        MINES_ADDRESS: '',
        LOOTBOX_MARKET: 'inj1agx7xlvczthf5eu8hz3yycnf65rmdc0rug8xld',
        COINFLIP_ADDRESS: 'inj14vs6laln2gd3fuz9r4gnps5luzga9g79uu8tv0',
        PLINKO_ADDRESS: 'inj1v6pcv030rqgmnt54td734um485xu8396dj5ehc',
        AUCTION_BASKET: 'inj1jyx0579sxs6hamzc2wmap4heqjyweg3g2z4kz0',
        LOOTBOX_UNLIMITED_CONTRACT: 'inj1gml3xced3zuwulau8uyh4kynpe7d8n0sddnjmm',

        RUNES_ADDRESS: '',

        BONUS_ACCOUNT: 'inj1dgfa0dp0plfxsdd2t2wd6xallh0h6cckwr807h',

        XACCOUNT: 'inj1cwtracgstf2ekgl8wzutztrdkunv78ww5k6jza',
      },

      NETWORK: Network.Local,
      ENDPOINTS: {
        ...getNetworkEndpoints(Network.Local)!,
        indexer: 'https://localhost:4448',
        grpc: 'http://localhost:9091',
        rest: 'http://localhost:10337',
        rpc_ws: 'ws://injectived:26657',
      }!,

      CHAIN_ID: ChainId.Mainnet,
      ETHEREUM_CHAIN_ID: EthereumChainId.Mainnet,
      ETHEREUM_RPC: 'https://eth-mainnet.g.alchemy.com/v2/xvBpvW4QoQbNaWH2FfnAJqOGj7eVTla3',

      INJ_DENOM: 'peggy0xdAC17F958D2ee523a2206206994597C13D831ec7',
      INJ_DENOM_BASE: 6,
      INJ_DENOM_NAME: 'INJ',
      INJ_DENOM_LOGO: '/assets/images/injective.png',
      INJ_DENOM_PRECISION: 3,

      USDC_DENOM: 'factory/inj17vytdwqczqz72j65saukplrktd4gyfme5agf6c/usdc',
      USDT_DENOM: '',

      SOL_DENOM: 'factory/inj1aetmaq5pswvfg6nhvgd4lt94qmg23ka3ljgxlm/sol',

      MAINTENANCE_INFO: '',
      IS_MAINTENANCE: false,
      IS_FIAT_ENABLED: true,

      FIREBASE_PREFIX: 'dev',
      PINATA_TOKEN:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiIwNjAxMjExNC1hMTU5LTRmNTctOGUxYy1hMjI0NGFjMTgwMjkiLCJlbWFpbCI6InBpbmF0YUBibGF6ZS5uaW5qYSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJwaW5fcG9saWN5Ijp7InJlZ2lvbnMiOlt7ImlkIjoiRlJBMSIsImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxfSx7ImlkIjoiTllDMSIsImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxfV0sInZlcnNpb24iOjF9LCJtZmFfZW5hYmxlZCI6ZmFsc2UsInN0YXR1cyI6IkFDVElWRSJ9LCJhdXRoZW50aWNhdGlvblR5cGUiOiJzY29wZWRLZXkiLCJzY29wZWRLZXlLZXkiOiJlN2NhYjVhM2IyYTk1MTYzOWIyYSIsInNjb3BlZEtleVNlY3JldCI6IjFiMzU1ZWMyZTBkYTZmOTY4YTRkNjYzOWExYWZjMjQyMzk5NTRjOTgxYTRjMDc3NWQwYzk4MjcxYzNmMjVkYmIiLCJpYXQiOjE3MDEyMTg1NTF9.fN7Xp_tdWhsIu_fq06Uc8FKEuSs_nB4uKLeRnIpZx-w',

      GALXE: {
        CAMPAIGN_ID: 'GC14gUnjB6',
        CLAIM_INTERVAL: 24 * 60 * 60,
      },

      INDEXER: 'https://ninja-blaze-testnet-api-c1qguw1k.ew.gateway.dev/indexer/',
      API_GATEWAY: 'https://app-testnet.blaze.ninja/api',
      GAME_API: 'https://app-mainnet.blaze.ninja/api-game',
      USE_API_GATEWAY_FOR_PROFILE: false,

      JACKPOT_FEE: 0.1,

      EXPLORERS: {
        INJECTIVE_WALLETS: 'https://testnet.explorer.injective.network/account/',
        INJECTIVE_BLOCKS: 'https://testnet.explorer.injective.network/block/',
        INJECTIVE_TRANSACTIONS: 'https://testnet.explorer.injective.network/transaction/',
      },

      OG_API: 'https://og-images.blaze.ninja/games',

      NOIS_GENESIS: 1677685200,
      LOOTBOX_ENV: 'testnet',
      FEE_PAYER: 'Anxo39kVD34Nq6ODjiuuKfTIQyQOvf2UiA212XjPEJ8a',
      GAS_PRICE: 160000000,
      THIRDWEB_CLIENT_ID: '692c24596fedba5caeb95eaf0b8b39a4',
      SUPABASE_URL: 'https://bcfwfjvpmaqpocddclyj.supabase.co',
      SUPABASE_KEY:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJjZndmanZwbWFxcG9jZGRjbHlqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDE4MDQwNzMsImV4cCI6MjAxNzM4MDA3M30.aqmwFGidwtPbuyyhO7Rv5tvuzr7S_2x5_QzvJMwcduU',

      CHANGENOW_API_KEY: '88c06f23ad5926133851b0837cec757ab7a7adc6d69ac2c321fe88f58b205ae4',
      NBZ_DENOM: 'factory/inj1aetmaq5pswvfg6nhvgd4lt94qmg23ka3ljgxlm/SHURIKEN',

      SQUID: {
        URL: 'https://api.0xsquid.com',
        INTEGRATOR_ID: 'ninja-blaze-d52aab8f-9efd-4d89-8f69-2b369f4f85dc',
      },

      OC: {
        START: '2 Sep 2024 00:00:00 GMT',
        FINISH: '22 Sep 2024 23:59:59 GMT',
      },
      LAUNCHPAD_START_DATE: '23 Jan 2025 15:00:00 UTC',
    }
  }

  if (network == 'testnet-dev') {
    return {
      ENVIRONMENT: Environmet.Testnet,
      NBZ_SDK: 'TESTNET',
      CONTRACTS: {
        USER_PROFILE_ADDRESS: 'inj13krv5rcdu94vuukfm7fymrjkywa76dzkdm7ey5',
        JACKPOT_ADDRESS: 'inj1xq0g5te6d07rrdf40zqkf3ftkfa3jazslgrypj',
        FAUCET: 'inj1dxz43ljhsxztgatjduwtwtt943dz8fqvy4d8cs',
        ROULETTE_ADDRESS: 'inj1u4qunsax0s2au8ml8jfjee7hv6stw9htspgvhk',
        MINES_ADDRESS: 'inj1mllhw9e20gyd995dzr67tyamkagnnqqnmz83vr',
        LOOTBOX_MARKET: 'inj1tan5afdxa4q6w9g567dpvndmydadyy4p08x46p',
        COINFLIP_ADDRESS: 'inj14vs6laln2gd3fuz9r4gnps5luzga9g79uu8tv0',
        PLINKO_ADDRESS: 'inj1v6pcv030rqgmnt54td734um485xu8396dj5ehc',
        AUCTION_BASKET: 'inj1jyx0579sxs6hamzc2wmap4heqjyweg3g2z4kz0',
        LOOTBOX_UNLIMITED_CONTRACT: 'inj1gml3xced3zuwulau8uyh4kynpe7d8n0sddnjmm',

        RUNES_ADDRESS: 'inj18esx40z8j98ummnpapuvdxl6jwl7pjcte720vf',

        BONUS_ACCOUNT: 'inj1dgfa0dp0plfxsdd2t2wd6xallh0h6cckwr807h',

        XACCOUNT: 'inj1cwtracgstf2ekgl8wzutztrdkunv78ww5k6jza',
      },
      NETWORK: Network.TestnetSentry,
      ENDPOINTS: {
        ...getNetworkEndpoints(Network.TestnetSentry),
        rpc_ws: 'wss://testnet.sentry.tm.injective.network',
        web3gw: 'https://injective-signer-944147187128.europe-west1.run.app',
      },

      CHAIN_ID: ChainId.Testnet,
      ETHEREUM_CHAIN_ID: 11155111 as any,
      ETHEREUM_RPC: 'https://eth-mainnet.g.alchemy.com/v2/xvBpvW4QoQbNaWH2FfnAJqOGj7eVTla3',

      INJ_DENOM: 'inj',
      INJ_DENOM_BASE: 18,
      INJ_DENOM_NAME: 'INJ',
      INJ_DENOM_LOGO: '/assets/images/injective.png',
      INJ_DENOM_PRECISION: 3,

      USDC_DENOM: 'factory/inj17vytdwqczqz72j65saukplrktd4gyfme5agf6c/usdc',
      USDC_NEW_DENOM: 'factory/inj17vytdwqczqz72j65saukplrktd4gyfme5agf6c/usdc',
      USDT_DENOM: 'factory/inj17vytdwqczqz72j65saukplrktd4gyfme5agf6c/usdc',

      SHU_DENOM: 'factory/inj1aetmaq5pswvfg6nhvgd4lt94qmg23ka3ljgxlm/sol',
      SOL_DENOM: 'factory/inj1aetmaq5pswvfg6nhvgd4lt94qmg23ka3ljgxlm/sol',

      MAINTENANCE_INFO: '',
      IS_MAINTENANCE: false,
      IS_FIAT_ENABLED: true,

      FIREBASE_PREFIX: 'dev',
      PINATA_TOKEN:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiIwNjAxMjExNC1hMTU5LTRmNTctOGUxYy1hMjI0NGFjMTgwMjkiLCJlbWFpbCI6InBpbmF0YUBibGF6ZS5uaW5qYSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJwaW5fcG9saWN5Ijp7InJlZ2lvbnMiOlt7ImlkIjoiRlJBMSIsImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxfSx7ImlkIjoiTllDMSIsImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxfV0sInZlcnNpb24iOjF9LCJtZmFfZW5hYmxlZCI6ZmFsc2UsInN0YXR1cyI6IkFDVElWRSJ9LCJhdXRoZW50aWNhdGlvblR5cGUiOiJzY29wZWRLZXkiLCJzY29wZWRLZXlLZXkiOiJlN2NhYjVhM2IyYTk1MTYzOWIyYSIsInNjb3BlZEtleVNlY3JldCI6IjFiMzU1ZWMyZTBkYTZmOTY4YTRkNjYzOWExYWZjMjQyMzk5NTRjOTgxYTRjMDc3NWQwYzk4MjcxYzNmMjVkYmIiLCJpYXQiOjE3MDEyMTg1NTF9.fN7Xp_tdWhsIu_fq06Uc8FKEuSs_nB4uKLeRnIpZx-w',

      INDEXER: 'https://ninja-blaze-testnet-api-c1qguw1k.ew.gateway.dev/indexer/',
      API_GATEWAY: 'https://app-testnet.blaze.ninja/api',
      USE_API_GATEWAY_FOR_PROFILE: true,
      GAME_API: 'https://app-testnet.blaze.ninja/api-game',

      GALXE: {
        CAMPAIGN_ID: 'GC14gUnjB6',
        CLAIM_INTERVAL: 24 * 60 * 60,
      },

      JACKPOT_FEE: 0.1,

      FEE_PAYER: 'Anxo39kVD34Nq6ODjiuuKfTIQyQOvf2UiA212XjPEJ8a',
      GAS_PRICE: 1600000000,

      EXPLORERS: {
        INJECTIVE_WALLETS: 'https://testnet.explorer.injective.network/account/',
        INJECTIVE_BLOCKS: 'https://testnet.explorer.injective.network/block/',
        INJECTIVE_TRANSACTIONS: 'https://testnet.explorer.injective.network/transaction/',
      },

      OG_API: 'https://og-images.blaze.ninja/games',

      NOIS_GENESIS: 1677685200,
      THIRDWEB_CLIENT_ID: '692c24596fedba5caeb95eaf0b8b39a4',

      LOOTBOX_ENV: 'testnet',

      SUPABASE_URL: 'https://bcfwfjvpmaqpocddclyj.supabase.co',
      SUPABASE_KEY:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJjZndmanZwbWFxcG9jZGRjbHlqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDE4MDQwNzMsImV4cCI6MjAxNzM4MDA3M30.aqmwFGidwtPbuyyhO7Rv5tvuzr7S_2x5_QzvJMwcduU',

      CHANGENOW_API_KEY: '88c06f23ad5926133851b0837cec757ab7a7adc6d69ac2c321fe88f58b205ae4',
      NBZ_DENOM: 'factory/inj1aetmaq5pswvfg6nhvgd4lt94qmg23ka3ljgxlm/SHURIKEN',

      SQUID: {
        URL: 'https://api.0xsquid.com',
        INTEGRATOR_ID: 'ninja-blaze-d52aab8f-9efd-4d89-8f69-2b369f4f85dc',
      },

      OC: {
        START: '2 Sep 2024 00:00:00 GMT',
        FINISH: '22 Sep 2024 23:59:59 GMT',
      },
      LAUNCHPAD_START_DATE: '2 Jan 2025 15:00:00 UTC',
    }
  }

  if (network == 'mainnet') {
    return {
      ENVIRONMENT: Environmet.Production,
      NBZ_SDK: 'MAINNET',
      CONTRACTS: {
        USER_PROFILE_ADDRESS: 'inj1p9mgq0lyvyxecv34cs0k8vjjwzgpehuklha7ky',
        JACKPOT_ADDRESS: 'inj197p43l6dw8m4zq8yg0f2tt8xmanklws7qmae3l',
        ROULETTE_ADDRESS: 'inj1mugjzyvqsty6e7wlex68qq3r2ar5vx95d0aq7m',
        MINES_ADDRESS: 'inj1hef2qa0t9gg6plrnz9mqv5yrjy4yxpfsmfx5cr',
        LOOTBOX_MARKET: 'inj1agx7xlvczthf5eu8hz3yycnf65rmdc0rug8xld',
        COINFLIP_ADDRESS: 'inj1rgtvmd33eys20tfqq67m0l3s6u2zphy3je8snt',
        PLINKO_ADDRESS: 'inj1l326t6p0hh8zmxm7cacmj4ztg9pnfkq307qdhr',
        AUCTION_BASKET: 'inj1f3qemxccs9vvz6kpc4x242q0gys238lrev4z8l',
        LOOTBOX_UNLIMITED_CONTRACT: 'inj1hxcve4umr7ke6hpnsnxmnzzn7pwfa22kz7lmzl',

        RUNES_ADDRESS: 'inj14s80jwg8d7js5c3elhqkeehylxqsh7zgg09ays',

        BONUS_ACCOUNT: 'inj10q7p2yrcengn8t86y3ac62xp6t05hz6wz096vc',

        XACCOUNT: 'inj1saj8mjjycftrkenkrrf9h0525ywj34ddsmmfn3',
      },
      NETWORK: Network.MainnetSentry,
      ENDPOINTS: {
        ...getNetworkEndpoints(Network.MainnetSentry),
        web3gw: 'https://app-mainnet.blaze.ninja/tx',
        grpc: 'https://injective-grpc-web.publicnode.com/8d420bf8abb380b69b7ddf1b9e28e309db958684a09628c9b83509cfcd06a5ea',
        rpc: 'https://injective-rpc.publicnode.com/8d420bf8abb380b69b7ddf1b9e28e309db958684a09628c9b83509cfcd06a5ea',
        rpc_ws: 'wss://injective-rpc.publicnode.com/8d420bf8abb380b69b7ddf1b9e28e309db958684a09628c9b83509cfcd06a5ea',
        rest: 'https://injective-rest.publicnode.com/8d420bf8abb380b69b7ddf1b9e28e309db958684a09628c9b83509cfcd06a5ea',
      },

      CHAIN_ID: ChainId.Mainnet,
      ETHEREUM_CHAIN_ID: EthereumChainId.Mainnet,
      ETHEREUM_RPC: 'https://eth-mainnet.g.alchemy.com/v2/xvBpvW4QoQbNaWH2FfnAJqOGj7eVTla3',

      INJ_DENOM: 'inj',
      INJ_DENOM_BASE: 18,
      INJ_DENOM_NAME: 'INJ',
      INJ_DENOM_LOGO: '/assets/images/injective.png',
      INJ_DENOM_PRECISION: 3,

      USDC_DENOM: 'ibc/2CBC2EA121AE42563B08028466F37B600F2D7D4282342DE938283CC3FB2BC00E',
      USDC_NEW_DENOM: 'erc20:0xa00C59fF5a080D2b954d0c75e46E22a0c371235a',

      USDT_DENOM: 'peggy0xdAC17F958D2ee523a2206206994597C13D831ec7',

      SOL_DENOM: 'ibc/A8B0B746B5AB736C2D8577259B510D56B8AF598008F68041E3D634BCDE72BE97',

      MAINTENANCE_INFO: '',
      // 'The platform will be unavailable due to maintenance on 17 February, from 14:15 UTC to 15:30 UTC.',
      IS_MAINTENANCE: false,
      IS_FIAT_ENABLED: true,

      FIREBASE_PREFIX: 'mainnet',

      INDEXER: 'https://app-mainnet.blaze.ninja/indexer/graphql',
      API_GATEWAY: 'https://app-mainnet.blaze.ninja/api',
      // API_GATEWAY: 'http://localhost:8080',
      GAME_API: 'https://app-mainnet.blaze.ninja/api-game',
      USE_API_GATEWAY_FOR_PROFILE: true,

      JACKPOT_FEE: 0.05,

      FEE_PAYER: 'AhTKGiOCoWFrqeFYpbBI7OkttemMPwHhUAbS91eMxXgA',
      FEE_PAYER_ACCOUNT: {
        baseAccount: {
          address: 'f',
          accountNumber: 1929453,
          sequence: 3,
        },
      },
      GAS_PRICE: 160000000,

      EXPLORERS: {
        INJECTIVE_WALLETS: 'https://explorer.injective.network/account/',
        INJECTIVE_BLOCKS: 'https://explorer.injective.network/block/',
        INJECTIVE_TRANSACTIONS: 'https://explorer.injective.network/transaction/',
      },

      OG_API: 'https://og-images.blaze.ninja/games',

      NOIS_GENESIS: 1677685200,

      LOOTBOX_ENV: 'mainnet-v2',

      THIRDWEB_CLIENT_ID: '692c24596fedba5caeb95eaf0b8b39a4',
      SUPABASE_URL: 'https://bcfwfjvpmaqpocddclyj.supabase.co',
      SUPABASE_KEY:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJjZndmanZwbWFxcG9jZGRjbHlqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDE4MDQwNzMsImV4cCI6MjAxNzM4MDA3M30.aqmwFGidwtPbuyyhO7Rv5tvuzr7S_2x5_QzvJMwcduU',

      CHANGENOW_API_KEY: '88c06f23ad5926133851b0837cec757ab7a7adc6d69ac2c321fe88f58b205ae4',
      NBZ_DENOM: 'factory/inj1llr45x92t7jrqtxvc02gpkcqhqr82dvyzkr4mz/NBZ',

      SHU_DENOM: 'factory/inj1llr45x92t7jrqtxvc02gpkcqhqr82dvyzkr4mz/SHU',

      SQUID: {
        URL: 'https://api.0xsquid.com',
        INTEGRATOR_ID: 'ninja-blaze-d52aab8f-9efd-4d89-8f69-2b369f4f85dc',
      },

      OC: {
        START: '02 Sep 2024 15:00:00 GMT',
        FINISH: '30 Sep 2024 15:00:00 GMT',
      },

      LAUNCHPAD_START_DATE: '23 Jan 2025 15:00:00 UTC',
    }
  }

  throw Error('Incorrect env')
}

const env = getNinjaBlazeEnv(process.env.NEXT_PUBLIC_APP_ENV as any)

export const OC_START = env.OC.START
export const OC_FINISH = env.OC.FINISH

export const NOIS_GENESIS = env.NOIS_GENESIS
export const ENVIRONMENT = env.ENVIRONMENT

export const EXPLORERS = env.EXPLORERS

export const JACKPOT_CONTRACT_ADDRESS = env.CONTRACTS.JACKPOT_ADDRESS
export const ROULETTE_CONTRACT_ADDRESS = env.CONTRACTS.ROULETTE_ADDRESS
export const MINES_CONTRACT_ADDRESS = env.CONTRACTS.MINES_ADDRESS
export const COINFLIP_CONTRACT_ADDRESS = env.CONTRACTS.COINFLIP_ADDRESS
export const PLINKO_CONTRACT_ADDRESS = env.CONTRACTS.PLINKO_ADDRESS

export const RUNES_CONTRACT_ADDRESS = env.CONTRACTS.RUNES_ADDRESS

export const AUCTION_BASKET_CONTRACT_ADDRESS = env.CONTRACTS.AUCTION_BASKET

export const LOOTBOX_UNLIMITED_CONTRACT = env.CONTRACTS.LOOTBOX_UNLIMITED_CONTRACT!
export const LOOTBOX_MARKET_ADDRESS = env.CONTRACTS.LOOTBOX_MARKET

export const BONUS_ACCOUNT_CONTRACT = env.CONTRACTS.BONUS_ACCOUNT

export const XACCOUNT_CONTRACT_ADDRESS = env.CONTRACTS.XACCOUNT

export const JACKPOT_FEE = env.JACKPOT_FEE

export const IS_MAINTENANCE = env.IS_MAINTENANCE
export const MAINTENANCE_INFO = env.MAINTENANCE_INFO
export const IS_FIAT_ENABLED = false

export const SUPABASE_URL = env.SUPABASE_URL
export const SUPABASE_KEY = env.SUPABASE_KEY

export const FAUCET_CONTRACT_ADDRESS = env.CONTRACTS.FAUCET

export const USER_PROFILE_CONTRACT = env.CONTRACTS.USER_PROFILE_ADDRESS

export const NETWORK = env.NETWORK
export const ENDPOINTS = env.ENDPOINTS

export const CHAIN_ID = env.CHAIN_ID
export const ETHREUM_CHAIN_ID = env.ETHEREUM_CHAIN_ID

export const INJ_DENOM = env.INJ_DENOM

export const INJ_DENOM_BASE = env.INJ_DENOM_BASE
export const INJ_DENOM_NAME = env.INJ_DENOM_NAME
export const INJ_DENOM_LOGO = env.INJ_DENOM_LOGO
export const INJ_DENOM_PRECISION = env.INJ_DENOM_PRECISION

export const USDT_DENOM = env.USDT_DENOM
export const USDT_DENOM_BASE = 6

export const USDC_DENOM = env.USDC_DENOM
export const USDC_DENOM_BASE = 6

export const USDC_NEW_DENOM = env.USDC_NEW_DENOM || ''

export const SOL_DENOM = env.SOL_DENOM
export const SOL_DENOM_BASE = 8

export const NBZ_DENOM = env.NBZ_DENOM
export const SHU_DENOM = env.SHU_DENOM || ''

export const NBZ_DENOM_BASE = 6

export const GALXE_CAMPAIGN_ID = env.GALXE?.CAMPAIGN_ID
export const CLAIM_INTERVAL = env.GALXE?.CLAIM_INTERVAL

export const SESSION_EXPIRY = 24 * 60 * 60 * 1000

export const ETH_RPC = 'https://eth-mainnet.g.alchemy.com/v2/xvBpvW4QoQbNaWH2FfnAJqOGj7eVTla3'

export const IPFS_GATEWAY = 'https://ipfs.blaze.ninja/ipfs/'

export const OG_API = env.OG_API

export const FIREBASE_PREFIX = env.FIREBASE_PREFIX

export const PINATA_TOKEN = env.PINATA_TOKEN

export const FEE_PAYER = env.FEE_PAYER
export const GAS_PRICE = env.GAS_PRICE

export const INDEXER = env.INDEXER

export const API_GATEWAY = env.API_GATEWAY

export const USE_API_GATEWAY_FOR_PROFILE = env.USE_API_GATEWAY_FOR_PROFILE

export const THIRDWEB_CLIENT_ID = env.THIRDWEB_CLIENT_ID

export const LOOTBOX_ENV = env.LOOTBOX_ENV

export const SQUID_CONFIG = env.SQUID

export const CHANGENOW_API_KEY = env.CHANGENOW_API_KEY

export const LAUNCHPAD_START_DATE = env.LAUNCHPAD_START_DATE

export const ASSETS_URL =
  process.env.NEXT_PUBLIC_ASSETS_LOCAL == 'true' ? 'http://localhost:9000' : 'https://assets.blaze.ninja'

export const GAME_API = env.GAME_API

export const FEE_PAYER_ACCOUNT = env.FEE_PAYER_ACCOUNT
export const FEE_PAYER_INJ = PublicKey.fromBase64(env.FEE_PAYER).toAddress().bech32Address

export const INTERCOM_APP_ID = ENVIRONMENT === Environmet.Production ? 'cos08kkr' : undefined

export const USDC_DENOM_NAME = 'USDC'

export const NBZ_SDK = env.NBZ_SDK
